module.exports = __webpack_public_path__ + "static/media/shoushan_package.0389f92a.webp";